import enquireJs from 'enquire.js'

// update-begin-author:jeayea date:20260727 for:多显示器不同缩放比拖动窗口导致左侧菜单消失
// 原逻辑注册了两条媒体查询：max-width:1087.99px(平板档) 和 max-width:767.99px(手机档)，
// 平板档命中即切换成 mobile，左侧菜单会被换成默认收起的抽屉，看上去就是"菜单不见了"。
// 双屏且两块屏缩放比不同时（如 100% / 150%），窗口在屏幕间拖动会按新屏重算 devicePixelRatio，
// CSS 像素宽度 = 物理宽度 ÷ 缩放比，很容易掉到 1088px 以下从而误判为移动端。
// update-end-author:jeayea date:20260727 for:多显示器不同缩放比拖动窗口导致左侧菜单消失

// update-begin-author:jeayea date:20260831 for:窄屏下内容区被常驻侧边栏挤窄、查询区不再自适应
// 上一版只留了手机档，768~1088px 一律按宽屏处理，左侧菜单常驻占 200px，
// 内容区被挤窄后查询表单排不开、表格横向溢出，看上去像"查询框变成了固定宽度"。
// 现拆成三档互斥区间（每次只有一条命中，切换时新档必定 match，无需依赖 unmatch 与注册顺序）：
//   -1 宽屏：桌面布局 + 菜单展开
//    0 窄屏：仍是桌面布局，菜单折叠成 80px 图标条，把宽度让给内容区（菜单不会消失）
//    1 手机：桌面布局降级为移动端，菜单收进抽屉
const enquireScreen = function (call) {
  // 手机档
  enquireJs.register('screen and (max-width: 767.99px)', {
    match: () => call && call(1)
  })
  // 窄屏档
  enquireJs.register('screen and (min-width: 768px) and (max-width: 1087.99px)', {
    match: () => call && call(0)
  })
  // 宽屏档
  enquireJs.register('screen and (min-width: 1088px)', {
    match: () => call && call(-1)
  })
}
// update-end-author:jeayea date:20260831 for:窄屏下内容区被常驻侧边栏挤窄、查询区不再自适应

export default enquireScreen
